import React from 'react';
import { useSelector } from 'react-redux';
import { PhoneIcon, DevicePhoneMobileIcon } from '@heroicons/react/20/solid';

export default function Footer() {

    const estimator = useSelector(state => state.estimator);
    const kiosk = useSelector(state => state.kiosk);

    const navigation = {
        main: [
            { name: 'Curbing', href: '/curbing' },
            { name: 'Concrete Resurfacing', href: '/armor-crete' },
            estimator.id !== 2 ? //Garry
                { name: 'Artificial Grass', href: '/grass' } : null,
            estimator.id !== 2 ? //Garry
                { name: 'Golf Solutions', href: '/golf' } : null,
            { name: 'Color Chart', href: '/color' },
            { name: 'Curb Profiles', href: '/profiles' },
            estimator.id !== 2 ? //Garry
                { name: 'Pricing', href: '/' } : null,
        ].filter(Boolean),

        social: [
            !kiosk ?
                {
                    name: '@curb_ease',
                    href: 'https://www.instagram.com/curb_ease/',
                    icon: (props) => (
                        <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                            <path
                                fillRule="evenodd"
                                d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                                clipRule="evenodd"
                            />
                        </svg>
                    ),
                } : null,
            {
                name: 'Testimonials',
                href: '/testimonials',
                icon: (props) => (
                    <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                        <path d="M4 4c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-5l-4 4v-4H6c-1.1 0-2-.9-2-2V4z" fill="none" stroke="currentColor" stroke-width="2" />
                        <circle cx="8" cy="10" r="1" fill="currentColor" />
                        <circle cx="12" cy="10" r="1" fill="currentColor" />
                        <circle cx="16" cy="10" r="1" fill="currentColor" />
                    </svg>
                ),
            },
            !kiosk ?
                {
                    name: estimator.phone,
                    href: 'tel:' + estimator.phone,
                    icon: PhoneIcon,
                } : null,
            !kiosk && estimator.sms ?
                {
                    name: `Text: ${estimator.sms}`,
                    href: `sms:${estimator.sms}?body=${encodeURIComponent("please schedule estimate")}`,
                    icon: DevicePhoneMobileIcon,
                } : null,
        ].filter(Boolean),
    }

    return (
        <footer className="bg-gray-800">
            <div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
                <nav className="-mb-6 columns-2 sm:flex sm:justify-center sm:space-x-12" aria-label="Footer">
                    {navigation.main.map((item) => (
                        <div key={item.name} className="pb-6">
                            <a href={item.href} className="text-sm leading-6 text-gray-400 hover:text-gray-500">
                                {item.name}
                            </a>
                        </div>
                    ))}
                </nav>
                <div className="mt-10 flex justify-center space-x-10 flex-wrap gap-4">
                    {navigation.social.map((item) => (
                        <a key={item.name} href={item.href} className="flex items-center text-gray-400 hover:text-gray-500">
                            <item.icon className="h-6 w-6 mr-2" aria-hidden="true" />
                            <span >{item.name}</span>
                        </a>
                    ))}
                </div>
                <p className="mt-10 text-center text-xs leading-5 text-gray-400">
                    {estimator.legal}
                    <a href="https://g.page/r/Ca1ye2Hv4S4nEBM" className="text-blue-500 hover:underline">Verified Google Business Profile</a>
                    &nbsp;|&nbsp;
                    <a href="/privacy-policy" className="text-blue-500 hover:underline">Privacy Policy</a>
                </p>
                <img
                    className="h-16 w-auto filter invert grayscale brightness-150 contrast-200"
                    src={require('../assets/canada.png')}
                    alt="Operated in Canada Logo"
                />

            </div>
        </footer>
    )
};
